<template>
  <div id="app">
    <SidePanel />
    <div id="wrapper" class="clearfix">
      <LandingHeader />
      <LandingContents />
      <Footer />
      <!-- <StickyFooter /> -->
    </div>
    <div id="gotoTop" class="icon-angle-up"></div>
  </div>
</template>

<script>
import SidePanel from "./components/SidePanel.vue";
import LandingHeader from "./components/LandingHeader.vue";
import LandingContents from "./components/LandingContents.vue";
import Footer from "./components/Footer.vue";
// import StickyFooter from "./components/StickyFooter.vue";

export default {
  name: "app",

  components: {
    SidePanel,
    LandingHeader,
    LandingContents,
    Footer
  },

  methods: {},

  mounted() {
    this.$i18n.locale = this.$route.query.locale;
    const html = document.documentElement 
    if(this.$i18n.locale){
      html.setAttribute('lang', this.$i18n.locale);      
    }
  },
  created() {
  },
  destroyed() {}
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Nanum+Myeongjo|Nanum+Gothic|Material+Icons&display=swap');
@import url('https://db.onlinewebfonts.com/c/05e476e067ffef74ca5686f229c40a63?family=PingFang+SC');

</style>
